import { render, staticRenderFns } from "./VideoNative.vue?vue&type=template&id=42128c38&"
import script from "./VideoNative.vue?vue&type=script&lang=js&"
export * from "./VideoNative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports